var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAz({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.001 512.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 311.908h512v102.988a8.829 8.829 0 0 1-8.828 8.828H8.828A8.829 8.829 0 0 1 0 414.896V311.908z",
    fill: "#73af00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.828 88.276h494.345a8.829 8.829 0 0 1 8.828 8.828v102.988H0V97.104a8.829 8.829 0 0 1 8.828-8.828z",
    fill: "#82afff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff4b55",
    d: "M0 200.09h512V311.9H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f5f5f5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.04 292.608c-19.81 0-35.881-16.071-35.881-35.898 0-19.792 16.071-35.898 35.881-35.898 7.371 0 14.168 2.266 19.832 6.103.867.588 1.857-.553 1.131-1.308-8.466-8.801-20.448-14.172-33.732-13.718-22.824.779-41.718 19.077-43.177 41.868-1.671 26.104 18.999 47.798 44.735 47.798 12.676 0 24.069-5.3 32.206-13.773.718-.748-.274-1.871-1.132-1.289-5.67 3.846-12.479 6.115-19.863 6.115z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.452 234.611l3.723 10.467 10.034-4.769c.756-.36 1.545.429 1.185 1.185l-4.769 10.034 10.467 3.723c.789.28.789 1.396 0 1.676l-10.467 3.723 4.769 10.034c.36.756-.429 1.545-1.185 1.185l-10.034-4.769-3.723 10.467c-.28.789-1.396.789-1.676 0l-3.723-10.467-10.034 4.769c-.756.36-1.545-.429-1.185-1.185l4.769-10.034-10.467-3.723c-.789-.28-.789-1.396 0-1.676l10.467-3.723-4.769-10.034c-.36-.756.429-1.545 1.185-1.185l10.034 4.769 3.723-10.467c.281-.788 1.396-.788 1.676 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAz);
export default __webpack_public_path__ + "static/media/az.092c4c54520d01af1966777455cf93b5.svg";
export { ForwardRef as ReactComponent };